import { Component, Vue, namespace, Watch } from 'nuxt-property-decorator';
import { IUser } from '../entities/user-entity';
import { namespace as userStore, actionType, ILoginParams, IRegistrationUserParams } from '../store/modules/user-store';
import { ITokensParams } from '../store/modules/auth-store';

const UserStore = namespace(userStore);

@Component
export default class UserMixin extends Vue {
	@UserStore.Action(actionType.LOGIN) login!: (params: ILoginParams) => ITokensParams;
	@UserStore.Action(actionType.REGISTER) registerUser!: (params: IRegistrationUserParams) => void;
	@UserStore.Action(actionType.LOGOUT) userLogout!: () => void;
	@UserStore.Action(actionType.REQUEST_PASSWORD) requestPassword!: (phoneNumber: string) => void;
	@UserStore.Action(actionType.GET_USER) getUser!: (params?: object) => Promise<IUser | boolean | undefined>;
	@UserStore.Getter('user') user!: IUser;
	@UserStore.Getter('isLoggedIn') isLoggedIn!: boolean;
	@UserStore.Getter('isLoadingUser') isLoadingUser!: boolean;
	@UserStore.Getter('isLoadedSuccess') isLoadedSuccess!: boolean;
	@UserStore.Getter('loading') loading!: { login: boolean; requestPassword: boolean };
	@UserStore.Getter('userError') userError!: unknown;

	username = '';
	address = '';
	phone = '';
	sex = '';
	birthday = '';
	email = '';

	@Watch('user', { immediate: true })
	onChangeUser(user: IUser): void {
		if (user) {
			this.username = user.username;
			this.address = user.address || '';
			this.phone = user.phone || '';
			this.sex = user.sexLabel || '';
			this.birthday = user.birthday || '';
			this.email = user.email || '';
		}
	}

	onLogout(): void {
		this.userLogout();
		this.$router.replace('/');
	}

	serializeForm(): unknown {
		return {
			username: this.username,
			address: this.address,
			phone: this.phone,
			sex: this.sex,
			birthday: this.birthday,
			email: this.email,
		};
	}

	submitForm(): void {
		// eslint-disable-next-line no-console
		console.log('on submit form ', this.serializeForm());
	}
}
